<mat-toolbar color="accent">Add Organisation</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content fxLayout="column">
    <mat-form-field class="w-full" required>
      <mat-label>Workspace Name</mat-label>
      <input type="text" matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Practice Name</mat-label>
      <input type="text" matInput formControlName="practiceName" />
    </mat-form-field>

    <mat-form-field class="w-full" required>
      <mat-label>Region</mat-label>
      <mat-select formControlName="region" required>
        @for (region of regions; track region) {
          <mat-option [value]="region">{{ region }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="w-full" required>
      <mat-label>Timezone</mat-label>
      <mat-select formControlName="timezone" required>
        @for (timezone of timezones; track timezone) {
          <mat-option [value]="timezone">{{ timezone }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (data && data.fileNames.length > 1) {
      <mat-form-field class="w-full" required>
        <mat-label>Workspace Presets</mat-label>
        <mat-select formControlName="seedFileName" required>
          @for (name of data.fileNames; track name) {
            <mat-option [value]="name">{{ name }}</mat-option>
          }
        </mat-select>
        <mat-hint>Select a file name to use as the source data.</mat-hint>
      </mat-form-field>
    }

    <mat-form-field class="w-full">
      <mat-label>User Name</mat-label>
      <input type="text" matInput formControlName="userName" />
      <mat-hint
        >Optionally set a user to also be added to the created
        organisation.</mat-hint
      >
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>User Email</mat-label>
      <input type="email" matInput formControlName="userEmail" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="form.invalid && form.pristine"
      >
        Save
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
